function CalendarSection({ events, loading, error, onEventClick }) {
  if (loading) return <section className="card"><h2>Upcoming Events</h2><p className="loading">Loading calendar...</p></section>;
  if (error) return <section className="card"><h2>Upcoming Events</h2><p className="error">{error}</p></section>;

  const now = new Date();
  const upcoming = events
    .filter((e) => e.end >= now)
    .slice(0, 7);

  function formatEventTime(event) {
    if (event.allDay) return 'All Day';
    return event.start.toLocaleTimeString('en-US', {
      timeZone: 'America/Chicago',
      hour: 'numeric',
      minute: '2-digit',
    });
  }

  function toChicagoDateStr(d) {
    return d.toLocaleDateString('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' });
  }

  function formatEventDate(date) {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const dateStr = toChicagoDateStr(date);
    if (dateStr === toChicagoDateStr(today)) return 'Today';
    if (dateStr === toChicagoDateStr(tomorrow)) return 'Tomorrow';
    return date.toLocaleDateString('en-US', { timeZone: 'America/Chicago', weekday: 'short', month: 'short', day: 'numeric' });
  }

  let lastDateStr = '';

  return (
    <section className="card calendar-section">
      <h2>Upcoming Events</h2>
      {upcoming.length === 0 ? (
        <p className="empty">No upcoming events</p>
      ) : (
        <ul className="event-list">
          {upcoming.map((event, i) => {
            const dateStr = formatEventDate(event.start);
            const showDate = dateStr !== lastDateStr;
            lastDateStr = dateStr;
            return (
              <li key={event.id + '-' + i}>
                {showDate && <div className="event-date-header">{dateStr}</div>}
                <div
                  className="event-item clickable"
                  onClick={() => onEventClick(event)}
                >
                  <span className="event-time">{formatEventTime(event)}</span>
                  <span className="event-title">{event.summary}</span>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}

export default CalendarSection;
